import React, { ReactNode } from 'react';
import { Link } from 'react-router-dom';
import Header from '../landing/contact/Header';

interface AuthLayoutProps {
  children: ReactNode;
  title: string;
  subtitle?: ReactNode;
}

const AuthLayout: React.FC<AuthLayoutProps> = ({ children, title, subtitle }) => {
  return (
    <div className='tw-overflow-hidden tw-h-lvh'>
        <Header />
      <div
        className="tw-w-lvw tw-h-[92vh]  tw-overflow-hidden tw-relative tw-grid md:tw-grid-cols-3 "

      >
        <div className="tw-col-span-2 tw-relative tw-flex tw-flex-col tw-items-start">
          <img src="/Auth/bgBlur.svg" draggable="false" onContextMenu={(e) => e.preventDefault()} className='tw-absolute tw-select-none' alt="" />
          

          <div className="tw-h-3/4 md:tw-w-3/6 tw-w-full tw-pt-20 tw-flex tw-flex-col tw-px-5 tw-justify-center md:tw-ml-32">
            <h2 className="tw-text-start tw-text-white tw-text-2xl sm:tw-text-3xl  tw-mb-2">
              {title}
            </h2>
            {subtitle && (
              <p className="  tw-text-sm tw-text-gray-400 tw-mb-16">
                {subtitle}
              </p>
            )}
            {children}
          </div>
        </div>
        <div className='tw-relative tw-h-[93vh] md:tw-block tw-hidden  tw-bg-cyan-500'>
          <img src="/Auth/auth.webp" className='tw-absolute -tw-left-1/2 tw-h-[70vh] tw-object-right tw-max-w-xl tw-rounded-2xl tw-top-2/4 -tw-translate-y-1/2 tw-object-cover' alt="Auth Image" />
        </div>
      </div>
    </div>
  );
};

export default AuthLayout;